var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrispark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.0766,
    r: 13.3408,
    fill: "#F9F9F9",
    stroke: "#DCDCDC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9335 9.26955C15.9545 9.26955 16.7822 8.44186 16.7822 7.42085C16.7822 6.39983 15.9545 5.57214 14.9335 5.57214C13.9125 5.57214 13.0848 6.39983 13.0848 7.42085C13.0848 8.44186 13.9125 9.26955 14.9335 9.26955Z",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5638 22.5803C15.3806 22.5803 16.0427 21.9181 16.0427 21.1013C16.0427 20.2845 15.3806 19.6223 14.5638 19.6223C13.747 19.6223 13.0848 20.2845 13.0848 21.1013C13.0848 21.9181 13.747 22.5803 14.5638 22.5803Z",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7402 18.4857C19.5048 17.2 18.5401 16.1703 17.2725 15.8517L16.3629 15.6239L15.9584 12.9618H17.152C18.5128 12.9673 19.7385 12.1395 20.2415 10.875L20.4234 10.4209C20.6454 9.8536 20.3683 9.21339 19.8028 8.98696C19.2372 8.76052 18.5948 9.03261 18.364 9.59641L18.1821 10.0512C18.0147 10.4732 17.6059 10.7496 17.152 10.7478H11.6058C10.5591 10.7506 9.57397 11.2431 8.9437 12.0789L8.72185 12.3007C8.48408 12.6177 8.4335 13.0375 8.58917 13.402C8.74484 13.7664 9.08311 14.0201 9.47655 14.0675C9.87 14.1149 10.2588 13.9488 10.4966 13.6318L10.7185 13.4099C10.9287 13.1315 11.257 12.9674 11.6058 12.9662H13.6808L14.1201 15.7718L12.3572 16.302C12.0588 16.3903 11.7372 16.3501 11.4698 16.1911L10.4611 15.5862C9.93571 15.2705 9.25385 15.4405 8.93815 15.9659C8.62246 16.4914 8.79246 17.1732 9.31788 17.4889L10.3265 18.0938C11.1295 18.575 12.0978 18.6963 12.9946 18.4281L14.8773 17.8631C15.2596 17.7484 15.6658 17.7389 16.0531 17.8357L16.7349 18.0058C17.1579 18.1112 17.4799 18.4547 17.5579 18.8836L18.2797 21.6707C18.3757 22.1974 18.8343 22.5804 19.3697 22.581C19.4368 22.5805 19.5039 22.5746 19.5701 22.5632C19.8596 22.5105 20.1163 22.345 20.2837 22.103C20.4511 21.8609 20.5155 21.5623 20.4626 21.2728L19.7402 18.4857Z",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrispark);
export default __webpack_public_path__ + "static/media/frispark.60cc5a3d841542cd8ae8b34038d69fac.svg";
export { ForwardRef as ReactComponent };